export function createMinValue(form, config) {
  return value => {
    const countryId = form.telephone_country_id;
    const country = config.telephone_country.find(el => el.id == countryId);

    if (!value) return true;
    if (!country) return true;
    if (value.length == country.phone_length && country.id == 1) return true;
    if (country.id != 1 && value.length <= country.phone_length) return true;
    return false;
  };
}
export function Script_checkID(id, c) {
  id = String(id);
  if (c.is_company == 1) return true;
  let i = 0,
    sum = 0;

  for (i = 0, sum = 0; i < 12; i++) sum += parseFloat(id.charAt(i)) * (13 - i);
  if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;
  return true;
}
